import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { InvoiceCollections } from "../../../models/Finance/InvoiceCollection/invoice-collections.model";
import { IInvoiceCollectionRepository } from "./IInvoiceCollectionRepository";


@Injectable()
export class InvoiceCollectionRepository extends GenericRepository<InvoiceCollections> implements IInvoiceCollectionRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/invoicecollection', environment.urlAddress);
    }
    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }
        return this._http
            .get(this.url + 'api/invoicecollection/SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }
    SaveRec(item: InvoiceCollections): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.GetById('/NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadRec(code: string): Observable<ResponseModel> {
        return this.GetById('/LoadRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
    DeleteRec(code: string): Observable<ResponseModel> {
        return this.Delete('/DeleteRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
    SelectPendingInvoice(code: string): Observable<any> {
        return this.GetById('/SelectPendingInvoice/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
    SelectPostingSetup(postingSetup: any, paymentType: number, accountCode: string,costCenterCode?: string): Observable<ResponseModel> {
        return this.PostData('/SelectPostingSetup' + '/' + paymentType + '/' + accountCode + '/' + costCenterCode, postingSetup).pipe(map(this.extractData), catchError(this.handleError));
    }

}